import * as ErlangConverter from './ErlangConverter';
import 'whatwg-fetch'
import 'promise-polyfill/src/polyfill';

export function fetchSomethingNoJson(passObject, postFunction, failFunction, filesSetArray){
      try{

        var data = new FormData();
        data.append("passObject",  JSON.stringify(passObject));
        if (!filesSetArray){
          filesSetArray = [];
        }
        for (var i in filesSetArray){
          data.append("files"+filesSetArray[i].name, filesSetArray[i]);
        }
        var loc = "/uploadFiles.yaws";
        fetch(loc, { 
          method: 'POST',
          body: data,
          contentType: "multipart/form-data",
          // cache: false,
          // processData: false, 
        })
        .then(function(response) {
          if (!response.ok) {
            return "fail";
          }else{
            return response.text();
          }
        })
      .then(function(data) {
          if (data === "fail"){
            if (failFunction){
              failFunction();
            }
          }else{       
            var converted = ErlangConverter.decode(data);
            postFunction(converted);
          }
        });
        return null;
      }catch(err) {
        console.log(err);
        if (failFunction){
          failFunction();
        }
        return [];
      }  
}


